module.exports = __webpack_public_path__ + "fa38042e3f8efd835ad367dc7bcd3f88.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/wasistgoldencity2.jpg
// module id = 784
// module chunks = 0